// permission.service.ts
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private permissions: { [key: string]: boolean } = {};

  setPermission(key: string, value: boolean) {
    this.permissions[key] = value;
  }

  hasPermission(key: string): boolean {
    return !!this.permissions[key];
  }
}
